import React from "react";
import { Col, Form, Row } from "react-bootstrap";

export default function HTTPSWebDropdown() {
  return (
    <div>
      <div className="align-items-center rounded-3 p-4 bg-purple-gradient-darker-reverse">
        <div className="ms-2">
          <span className="fs-4 fw-bold "> HTTPS Web Service</span>
        </div>
        <div className="text-secondary ms-2">
          Enable secure communication by configuring your HTTPS endpoint.
        </div>
        <div className="ms-3 my-3">
          <div>
            <Form.Group as={Row} className="mb-3" controlId="iPWhitelisting">
              <Form.Label className="fw-bold">IP whitelisting:</Form.Label>
              <Col sm="10">
                <Form.Control type="text" />
              </Col>
            </Form.Group>
          </div>
          <div>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="specificEmailAddress"
            >
              <Form.Label className="fw-bold">Other(DK): </Form.Label>
              <Col sm="10">
                <Form.Control type="text" />
              </Col>
            </Form.Group>
          </div>
        </div>
      </div>
    </div>
  );
}
